import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLock2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLock2"><Path d="M4.5 14.5C4.5 10.634 8.13401 7 12 7C15.866 7 19.5 10.634 19.5 14.5C19.5 18.366 15.866 22 12 22C8.13401 22 4.5 18.366 4.5 14.5Z" stroke="currentColor"/><Path d="M16 8.25V6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6V8.25" stroke="currentColor"/><Path d="M12 12V17" stroke="currentColor"/></CentralIconBase>;
});

export default IconLock2;
